<template>
  <div data-testid="dialog-box-new">
    <!-- <span @click="openDialog(true)">
      <slot name="button" />
    </span> --> 
    <v-dialog v-model="value" :max-width="width" :content-class="contentClass" scrollable persistent :transition="computedTransition" data-testid="dialog-box-new__dialog">
      <v-card :loading="loading" :disabled="loading" loader-height="2" data-testid="dialog-box-new__card">
        <v-card-title class="popupHeader align-center py-2 px-4" data-testid="dialog-box-new__card-title">
          <h5 class="font-size-md noTransform white--text" data-testid="dialog-box-new__card-title-text">{{ heading }}</h5>
          <v-spacer></v-spacer>
          <v-btn icon @click="openDialog(false)" class="white--text dialog-close-btn-always-enabled" data-testid="dialog-box-new__close-btn"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-4" data-testid="dialog-box-new__card-text">
          <slot name="body" data-testid="dialog-box-new__body" />
        </v-card-text>
        <v-card-actions class="py-4 px-6 justify-end" data-testid="dialog-box-new__card-actions">
          <slot name="actions" data-testid="dialog-box-new__actions" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogBox",
  data: function(){
    return {
      dialog: false,
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: "",
    },
    contentClass: {
      type: String,
      default: "",
    },
    width: {
      type: [String,Number],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: "",
      validator: (value) => ["", "bottom", "top", "right", "left"].includes(value),
    },
  },
  computed: {
    computedTransition() {
      const transitionMap = {
        bottom: "dialog-bottom-transition",
        top: "dialog-top-transition",
        right: "dialog-right-transition",
        left: "dialog-left-transition",
      };
      return transitionMap[this.transition] || "dialog-transition";
    },
  },
  created(){
    this.dialog = this.value;
  },
  activated(){
    this.dialog = this.value;
  },
  methods: {
    openDialog(v) {
      this.$emit("input", v);
      this.$emit("change", v);
    },
  },
  watch: {
    dialog(v) {
      this.openDialog(v);
    },
    value(v) {
      this.dialog = v;
    }
  }
};
</script>

<style>
.dialog-close-btn-always-enabled {
  pointer-events: auto !important;
  opacity: 1 !important;
}
/* Custom right transition */
.dialog-right-transition-enter-active,
.dialog-right-transition-leave-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.dialog-right-transition-enter,
.dialog-right-transition-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Custom left transition */
.dialog-left-transition-enter-active,
.dialog-left-transition-leave-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.dialog-left-transition-enter,
.dialog-left-transition-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
